import React from 'react'
import { Box, Divider, Skeleton } from '@machobear/design-system'

import * as styles from './ListingCard.css'

type Props = {
  variant?: 'vertical' | 'horizontal'
  featured?: boolean
}

const SkeletonCard = ({ variant = 'vertical', featured = false }: Props) => {
  return (
    <Box
      borderRadius="large"
      background="white"
      style={{ height: '393px', overflow: 'hidden' }}
      boxShadow="xsmall"
      display="flex"
      flexDirection="column"
      border="borderNeutralLight"
      className={styles.responsiveCard}
    >
      {/* Image skeleton */}
      <Box position="relative">
        <Skeleton.Shape width="100%" height={200} borderRadius="none" />

        {featured && (
          <Box
            position="absolute"
            style={{ top: 12, left: 12 }}
            display="flex"
            gap="xxsmall"
          >
            <Skeleton.Shape width={120} height={22} />
          </Box>
        )}
      </Box>

      {/* Details skeleton */}
      <Box
        display="flex"
        flexDirection="column"
        gap="xsmall"
        padding="small"
        justifyContent="spaceBetween"
        height="full"
        style={{ flex: 1 }}
      >
        <Box
          display="flex"
          justifyContent="spaceBetween"
          alignItems="flexStart"
        >
          <Box display="flex" flexDirection="column" gap="xxsmall">
            <Skeleton.Shape width={120} height={18} />
            <Skeleton.Shape width={150} height={14} />
          </Box>

          <Skeleton.Shape width={24} height={24} />
        </Box>

        <Divider />

        <Box display="flex" alignItems="center" gap="xxsmall">
          <Skeleton.Shape width={100} height={14} />
          <Skeleton.Shape width={16} height={14} />
        </Box>

        <Skeleton.Shape width={180} height={14} />

        <Box display="flex" gap="small">
          <Skeleton.Shape width="100%" height={40} />
        </Box>
      </Box>
    </Box>
  )
}

export default SkeletonCard
